function generateTOC(e,s) {
  const toc = document.getElementById(e);
  const headings = document.querySelectorAll(s);
  const list = document.createElement("ul");

  headings.forEach((heading, index) => {
    // Ensure each heading has an ID
    if (!heading.id) {
      heading.id = "heading-" + index;
    }
    const li = document.createElement("li");
    const link = document.createElement("a");
    link.href = "#" + heading.id;
    link.textContent = heading.textContent;
    li.appendChild(link);
    list.appendChild(li);
  });

  toc.appendChild(list);
}   
window.generateTOC = generateTOC;